export const gridTileScales = [0.35, 0.8];

export const imageSizingMapping = {
    // 'largest': [1921, 100000],
    'desktop': [1201, 100000], 
    'tablet': [601, 1200],
    'mobile': [101, 600],
    'placeholder': [0, 101]
}

// Supported browsers
export const supportedBrowsers = {
    'safari': 15.4,
    'chrome': 12.5,
    'firefox': 12.5
  }